import { render, staticRenderFns } from "./Schulungsplan.vue?vue&type=template&id=27476bca&scoped=true"
import script from "./Schulungsplan.vue?vue&type=script&lang=js"
export * from "./Schulungsplan.vue?vue&type=script&lang=js"
import style0 from "./Schulungsplan.vue?vue&type=style&index=0&id=27476bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27476bca",
  null
  
)

export default component.exports